export default __webpack_public_path__ + "static/media/5-2.ed1eac94.mp3";